import React, { Component } from "react";
import {
  createAdminCertificatesUsers,
  getAdminCertificatesUsers,
} from "../../../actions/users";
import { connect } from "react-redux";
import Pagination from "components/Pagination/TablePagination";

const labels = ["", "Name", "Email"];

class AddCertificates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      per_page: 50,
      search: "",
      user_ids: [],
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers = () => {
    //default or group webinar
    const webinar_id = this.props.params.webinarId
      ? this.props.params.webinarId
      : this.props.params.id;

    const { user_ids, ...rest } = this.state;
    const params = { ...rest, webinar_id };
    this.props.getAdminCertificatesUsers(params);
  };

  handleQueryChange = (search, timeout = 500) => {
    this.setState({ search }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.getUsers, timeout);
    });
  };

  onChangePage = (page) => this.setState({ page }, this.getUsers);

  handleCheck = (id) =>
    this.state.user_ids.includes(id)
      ? this.setState({
          user_ids: this.state.user_ids.filter((userId) => userId !== id),
        })
      : this.setState({ user_ids: [...this.state.user_ids, id] });

  handleCreate = () => {
    if (this.state.user_ids.length) {
      const groupId = this.props.params.webinarId ? this.props.params.id : null;
      const webinar_id = this.props.params.webinarId
        ? this.props.params.webinarId
        : this.props.params.id;

      this.props.createAdminCertificatesUsers({
        webinar_id: webinar_id,
        user_ids: this.state.user_ids,
        groupId,
      });
    }
  };

  render() {
    const { search, page, user_ids } = this.state;
    const { users } = this.props;

    const count = users ? users.count : 0;
    const totalPages = users ? users.totalPages : 0;
    const data = users ? users.data : [];

    return (
      <main className="site--width container_statistics">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <h5>Users({count})</h5>
          <button className="button_classic" onClick={this.handleCreate}>
            Add Certificates
          </button>
        </div>
        <div className="container_admin_user">
          <div className="search_admin">
            <input id="search" type="submit" className="validate" />
            <label htmlFor="search">
              <i className="material-icons icon_search">search</i>
            </label>
            <input
              type="search"
              placeholder="Search"
              value={search}
              onChange={(e) => this.handleQueryChange(e.target.value)}
            />
            <i
              className="material-icons icon_close"
              onClick={() => this.handleQueryChange("")}
            >
              close
            </i>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              {labels.map((label, idx) => (
                <th key={idx}>{label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map(({ id, first_name, last_name, email }) => (
              <tr key={id}>
                <td>
                  <p>
                    <input
                      type="checkbox"
                      className="filled-in"
                      id={`filled-in-box-${id}`}
                      checked={user_ids.includes(id)}
                      onChange={() => this.handleCheck(id)}
                    />
                    <label htmlFor={`filled-in-box-${id}`} />
                  </p>
                </td>
                <td>
                  {first_name} {last_name}
                </td>
                <td>{email}</td>
              </tr>
            ))}
            <tr></tr>
          </tbody>
        </table>
        <Pagination
          onChangePage={this.onChangePage}
          page={page}
          total_pages={totalPages}
        />
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    users: state.users.certificatesUsers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAdminCertificatesUsers: (params) =>
      dispatch(getAdminCertificatesUsers(params)),
    createAdminCertificatesUsers: (payload) =>
      dispatch(createAdminCertificatesUsers(payload)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCertificates);



// WEBPACK FOOTER //
// ./src/containers/Admin/AddCertificates/index.jsx